import { downloadBlob } from '../utils';
import { getSvgExportPayload } from './extractSvg';

export const exportSvg = (options: { container: HTMLElement | null; fileName: string }) => {
  const payload = getSvgExportPayload(options.container);
  if (!payload || !payload.svgString.trim()) {
    return;
  }

  const blob = new Blob([payload.svgString], { type: 'image/svg+xml;charset=utf-8' });
  downloadBlob(blob, `${options.fileName}.svg`);
};
